import { Component } from '@angular/core';
import { PageLoadingService } from './page-loading.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-page-loading',
  templateUrl: './page-loading.component.html',
  styleUrls: ['./page-loading.component.scss']
})
export class PageLoadingComponent {
  loading$ = this.loadingService.loading$;

  constructor(private loadingService: PageLoadingService) { }
}
